export default __webpack_public_path__ + "static/media/three-dots.1b5ac12d.svg";